import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import type { FeatureKey } from '../types'
import { UpgradeDialog } from '../components/UpgradeDialog'

/** Ne istendi: paketinde olmayan bir özellik ya da dolan personel sınırı. */
export type UpgradeAsk = FeatureKey | 'staff'

const UpgradeContext = createContext<(what: UpgradeAsk) => void>(() => {})

/**
 * Paketinde olmayan özellik kilitli görünür (29 Eki 2026, kullanıcı): basınca
 * hangi pakette olduğunu söyleyen ve yükseltme talebi gönderen pencere açılır.
 * Pencere tek, uygulamanın kökünde; her ekran yalnız askUpgrade çağırıyor.
 */
export function UpgradeProvider({ children }: { children: ReactNode }) {
  const [ask, setAsk] = useState<UpgradeAsk | null>(null)
  const open = useCallback((what: UpgradeAsk) => setAsk(what), [])
  return (
    <UpgradeContext.Provider value={open}>
      {children}
      {ask && <UpgradeDialog what={ask} onClose={() => setAsk(null)} />}
    </UpgradeContext.Provider>
  )
}

export const useUpgrade = () => useContext(UpgradeContext)
